import { SET_LOCATIONS } from './default-settings-mutation-types';
import api from '@/services/api-service';
import buildRoute from '@/composables/build-route';
import Vue from 'vue';

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: 'defaultSettings',
	namespaced: true,
	state: {
		locationsResults: {}
	},
	mutations: {
		[SET_LOCATIONS](state, { companyId, locationsResults }) {
			Vue.set(state.locationsResults, companyId, locationsResults);
		}
	},
	actions: {
		// actions let us get to ({ state, getters, commit, dispatch })
		async getLocationsAction({ commit }, companyId) {
			const locationsResults = await api.get(
				buildRoute('/dealership/company/{companyId}/locations', {
					companyId: companyId
				})
			);

			commit(SET_LOCATIONS, { companyId, locationsResults });
		}
	},
	getters: {
		locationsResults: state => companyId => {
			let results = {};

			if (state.locationsResults && state.locationsResults[companyId]) {
				results = state.locationsResults[companyId];
			}

			return results;
		}
	}
};
